module.exports = __webpack_public_path__ + "static/media/pla_green_strew1.0f50be90.png";